
export const bytesToUnitString = (
    bytes                       : number,
    precision                   : number = 2,
    addSpaceBetweenValueAndUnit : boolean = false,
): string => {

    const units = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    let exp = 0;
    let convertedValue = 0;

    if(bytes > 0)
    {
        exp = Math.floor(Math.log(bytes) / Math.log(1000));
        convertedValue = Math.round(bytes / Math.pow(1000, Math.floor(exp)) * (10**precision)) / (10**precision);
    }

    return convertedValue + (addSpaceBetweenValueAndUnit ? " " : "") + units[exp];

}
